import { AcademicLevel } from '@/plugins/api'
import alert from '@/plugins/alert'
export default {
  namespaced: true,
  state: {
    primary: {},
    secondary: {},
    high: {},
    academics: [],
    totalCount: 0,
    loading: false,
    searchQuery: {},
  },
  actions: {
    async fetchAcademics({ commit }, { notSetStore = false, ...options } = {}) {
      try {
        const academics = await AcademicLevel.fetch({ ...options })
        if (!notSetStore) {
          commit('changeAcademic', academics)
        }
        return academics
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchAcademicsWithChild({ commit }, params) {
      try {
        const academics = await AcademicLevel.fetchAcademicLevel({ ...params })
        commit('changeAcademic', academics)
        return academics
      } catch (error) {
        alert.error(error)
      }
    },
    async createAcademic({ commit }, options) {
      try {
        await AcademicLevel.create(options)
      } catch (error) {
        alert.error(error)
      }
    },
    async countAcademics({ commit }, options) {
      try {
        const totalCount = await AcademicLevel.count(options)
        commit('changeState', { totalCount })
      } catch (error) {
        alert.error(error)
      }
    },
    async updateAcademic({ commit }, { id, ...academic }) {
      try {
        await AcademicLevel.update(id, academic)
      } catch (e) {
        alert.error(e)
      }
    },
    async updateAcademicWithChildren({ commit }, data) {
      try {
        await AcademicLevel.updateAcademicLevel(data)
      } catch (e) {
        alert.error(e)
      }
    },
    async deleteAcademic({ commit }, id) {
      try {
        await AcademicLevel.remove(id)
      } catch (e) {
        alert.error(e)
      }
    },
  },
  mutations: {
    changeAcademic(state, data) {
      state.academics = data
    },
    setLoading(state, value) {
      state.loading = value
    },
    setSearchQuery(state, value) {
      state.searchQuery = value
    },
  },
}
